// ===================================================================
// PHOENIX OS — SERVIÇO DE PAGAMENTO (lado do app)
// ===================================================================
// Este arquivo vai em src/services/asaasService.js (mesma pasta do seu
// firebase.js). Ele só CHAMA as Cloud Functions — nunca fala direto
// com o Asaas, nunca vê a chave secreta.
// ===================================================================

import { getFunctions, httpsCallable } from 'firebase/functions';
import { app } from './firebase'; // ajuste o caminho se o seu firebase.js exportar diferente

const functions = getFunctions(app, 'southamerica-east1');

export async function criarClienteAsaas({ nome, email, cpfCnpj, telefone }) {
    const chamar = httpsCallable(functions, 'criarClienteAsaas');
    const resultado = await chamar({ nome, email, cpfCnpj, telefone });
    return resultado.data; // { customerId, reaproveitado }
}

export async function criarAssinaturaAsaas({ customerId, valor, descricao, formaPagamento, diaVencimento, planId }) {
    const chamar = httpsCallable(functions, 'criarAssinaturaAsaas');
    const resultado = await chamar({ customerId, valor, descricao, formaPagamento, diaVencimento, planId });
    return resultado.data; // { subscriptionId, status, linkFatura }
}

export async function criarCobrancaAvulsaAsaas({ customerId, valor, descricao, formaPagamento, planId, dossieId }) {
    const chamar = httpsCallable(functions, 'criarCobrancaAvulsaAsaas');
    const resultado = await chamar({ customerId, valor, descricao, formaPagamento, planId, dossieId });
    return resultado.data; // { paymentId, status, linkFatura }
}

// imediato=true só na exclusão de conta. Normal: acesso mantido até o fim do período já pago.
export async function cancelarAssinaturaAsaas({ subscriptionId, imediato = false }) {
    const chamar = httpsCallable(functions, 'cancelarAssinaturaAsaas');
    const resultado = await chamar({ subscriptionId, imediato });
    return resultado.data; // { cancelado, imediato, acessoAte }
}

export async function aplicarDescontoDuplaAssinatura({ subscriptionId }) {
    const chamar = httpsCallable(functions, 'aplicarDescontoDuplaAssinatura');
    const resultado = await chamar({ subscriptionId });
    return resultado.data; // { aplicado, valorOriginal, valorComDesconto, reverterEm }
}